import Service from "@/services";

export default {
  namespaced: true,

  state: {
    publicTeams: [],
    myTeams: [],
    loading: false,
    pagination: {
      currentPage: 1,
      lastPage: 1,
      perPage: 10,
      total: 0,
    },
  },

  getters: {
    publicTeams: (state) => state.publicTeams,
    myTeams: (state) => state.myTeams,
    loading: (state) => state.loading,
    pagination: (state) => state.pagination,
  },

  actions: {
    // Fetch public teams (no auth)
    async fetchPublicTeams({ commit }, { page = 1, limit = 10 } = {}) {
      try {
        commit("SET_LOADING", true);
        const res = await Service().get(
          "../api/team-management/get-public-teams",
          {
            params: { page, limit },
          }
        );

        commit("SET_PUBLIC_TEAMS", res.data.data || res.data);

        // Handle pagination
        if (res.data.page) {
          commit("SET_PAGINATION", {
            currentPage: res.data.page,
            lastPage: res.data.totalPages,
            perPage: res.data.limit,
            total: res.data.totalCount,
          });
        }

        return res;
      } catch (e) {
        console.log("Error fetching public teams: ", e);
        commit("SET_PUBLIC_TEAMS", []);
      } finally {
        commit("SET_LOADING", false);
      }
    },

    // Fetch user's teams (auth required)
    async fetchMyTeams(
      { commit },
      { type = "all", ownTeams = false, page = 1, limit = 10 } = {}
    ) {
      try {
        commit("SET_LOADING", true);

        const res = await Service().post("../api/team-management/get-teams", {
          type,
          ownTeams: ownTeams.toString(),
          page,
          limit,
        });

        commit("SET_MY_TEAMS", res.data.data || res.data);

        // Handle pagination
        if (res.data.page) {
          commit("SET_PAGINATION", {
            currentPage: res.data.page,
            lastPage: res.data.totalPages,
            perPage: res.data.limit,
            total: res.data.totalCount,
          });
        }

        return res;
      } catch (e) {
        console.log("Error fetching my teams: ", e);
        commit("SET_MY_TEAMS", []);
      } finally {
        commit("SET_LOADING", false);
      }
    },
  },

  mutations: {
    SET_PUBLIC_TEAMS: (state, payload) => (state.publicTeams = payload),
    SET_MY_TEAMS: (state, payload) => (state.myTeams = payload),
    SET_LOADING: (state, payload) => (state.loading = payload),
    SET_PAGINATION: (state, payload) => (state.pagination = payload),
  },
};
